import CustomLexiconCreateContainer from './CustomLexiconCreateContainer';
export default CustomLexiconCreateContainer;
